import {apiGetUserInfo,apiGetModulesByUserId} from '../apis/api';
let checkStatus=false
apiGetUserInfo().then( async res=>{
  if(res.data.resultInfo.success){
    let resp=await apiGetModulesByUserId(res.data.resultInfo.data.pkid)
    if(resp.data.success){
      let userModul=resp.data.data.modules[0].children
      checkModule(userModul)
      if(!checkStatus){
        window.history.back(-1);
      }
    }
  }
})
function checkModule(userModul) {
  userModul.forEach(item=>{
    if(item.href && item.href.indexOf('map')>-1){
      checkStatus=true
      return
    }
    if(item.children && item.children.length>0){
      checkModule(item.children)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/checkModule.js